import campaigns from '../api/campaigns'
import affiliates from "@/api/affiliates";

export default {
  state: {
    campaigns: {},
    offerNames: [],
    campaignNames: [],
    affNamesIds: [],
    managersNamesIds: [],
    campaignStatuses: [],
    users: []
  },
  namespaced: true,
  mutations: {
    async saveCampaignsStore(state, campaigns) {
      state.campaigns = campaigns
    },
    async saveCampaignStatusesStore(state, statuses) {
      state.campaignStatuses = statuses
    },
    async saveOfferNamesStore(state, offers) {
      state.offerNames = offers
    },
    async saveCampaignNamesStore(state, campaigns) {
      state.campaignNames = campaigns
    },
    async saveAffNamesIdsStore(state, affiliates) {
      state.affNamesIds = affiliates
    },
    async saveManagersNamesIdsStore(state, managers) {
      state.managersNamesIds = managers
    },
    async saveUsersStore(state, user) {
      state.users = user
    },
    async saveCampaignStore(state, campaign) {
      // todo: campaign is empty string here need to fix that
      // state.campaigns.data.push(campaign)
      // state.campaigns = {...state.campaigns}
    },
    async updateCampaignStore(state, campaign) {
      const newData = [...state.campaigns.data];
      const ind = newData.findIndex((cmp => cmp.id === campaign.id));
      newData[ind] = {
        ...newData[ind],
        status: campaign.status,
        payOut: campaign.payOut,
        name: campaign.name,
        percentPayout: campaign.percentPayout,
        marginType: campaign.marginType,
        programId: campaign.programId,
        programName: campaign.programName,
        affiliateMultiPings: campaign.affiliateMultiPings
      };

      state.campaigns = {
        ...state.campaigns,
        data: newData
      }
    },

    async updateCapStore(state, cap) {
      const newData = [...state.campaigns.data];
      const ind = newData.findIndex((cmp => cmp.id === cap.campaignId));

      console.log('ind', ind);
      console.log('before', JSON.stringify(newData[ind]));

      newData[ind] = {
        ...newData[ind],
        capId: cap.id,
        sales_day: cap.salesDay,
        sales_week: cap.salesWeek,
        sales_month: cap.salesMonth,
        sales_redirect_offer_id: cap.salesRedirectOfferId ,
        clicks_day: cap.clicksDay,
        clicks_week: cap.clicksWeek,
        clicks_month: cap.clicksMonth,
        clicks_redirect_offer_id: cap.clicksRedirectOfferId,
        startDate: cap.startDate,
        endDate: cap.endDate,
        enabled: cap.enabled
      };

      console.log('after', JSON.stringify(newData[ind]));

      state.campaigns = {
        ...state.campaigns,
        data: newData
      }

    },

  },
  actions: {
    async saveCampaigns({commit, dispatch}, data) {
      try {
        commit('saveCampaignsStore', await campaigns.getCampaigns(data))
      } catch (err) {
        dispatch('alert/ALERT_ERROR', err.message, {root: true});
      }
    },
    async saveCampaignStatuses({commit}, data) {
      commit('saveCampaignStatusesStore', await campaigns.getCampaignStatuses(data))
    },
    async saveOfferNames({commit}, data) {
      commit('saveOfferNamesStore', await campaigns.getOfferNames(data))
    },
    async saveCampaignNames({commit}, data) {
      commit('saveCampaignNamesStore', await campaigns.getCampaignNames(data))
    },
    async saveAffNamesIds({commit}, data) {
      commit('saveAffNamesIdsStore', await campaigns.getAffNamesIds(data))
    },
    async saveManagersNamesIds({commit}, data) {
      commit('saveManagersNamesIdsStore', await campaigns.getManagersNamesIds(data))
    },
    async saveUsers({commit}, data) {
      commit('saveUsersStore', await campaigns.getUsers(data))
    },
    // eslint-disable-next-line no-unused-vars
    async createCampaign({commit, dispatch}, data) {
      try {
        commit('saveCampaignStore', await campaigns.createCampaign(data));
      } catch (err) {
        dispatch('alert/ALERT_ERROR', err.message, {root: true});
        throw err;
      }
    },
    // eslint-disable-next-line no-unused-vars
    async getCampaignUrl({commit}, data) {
      return await campaigns.getCampaignUrl(data)
    },
    async getCampaigns({commit, dispatch}, data) {
      commit('saveCampaignsStore', await campaigns.getCampaignsData(data))
    },
    async updateCampaign({commit, dispatch}, data) {
      commit('updateCampaignStore', await campaigns.updateCampaign(data))
      return true;
    },
    async updateCap({commit, dispatch}, data) {
      commit('updateCapStore', await campaigns.updateCap(data))
      return true;
    },

  },
  getters: {
    getCampaigns: state => state.campaigns,
    getOfferNames: state => state.offerNames,
    getCampaignNames: state => state.campaignNames,
    getAffNamesIds: state => state.affNamesIds,
    getManagersNamesIds: state => state.managersNamesIds,
    getCampaignStatuses: state => state.campaignStatuses,
    getUsers: state => state.users,
    getCampaignsFilter: state => (
      {
        offer: state.offerNames,
        campaign_name: state.campaignNames,
        aff_name_id: state.affNamesIds,
        campaign_status: state.campaignStatuses,
        manager_name_id: state.managersNamesIds
      }
    )
  },

}
